import React, { useEffect, useState } from "react";
import "../../../src/App.css";
import Footer from "../../Components/footer/Footer";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

import {
  facebooklogo,
  instagramlogo,
  twitterlogo,
  whitearrowicon,
  grouplogo,
} from "../../assets/Exportimageicon";

export default function Community() {
  const [communityData, setCommunityData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCommunity = async () => {
      try {
        const res = await service.get(
          endpoints.community.record,
          {},
          {
            skipToast: true,
          }
        );
        setCommunityData(res?.data?.data?.data || null);
      } catch (error) {
        console.error("Error fetching community:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCommunity();
  }, []);

  const getSocialIcon = (platform) => {
    switch (platform?.toLowerCase()) {
      case "instagram":
        return instagramlogo;
      case "facebook":
        return facebooklogo;
      case "twitter":
      case "x":
        return twitterlogo;
      default:
        return grouplogo;
    }
  };

  if (loading) {
    return (
      <div className="cm-root">
        <div
          style={{
            minHeight: "60vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          Loading Community...
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cm-root">
      <main className="cm-main mt-5">
        {/* LEFT SECTION */}
        <div className="cm-left">
          <h1 className="cm-heading">Community</h1>

          <p className="cm-subtext">
            {communityData?.heading ||
              "Whether you have a question, want to work together, or simply wish to say hello, I'm all ears."}
          </p>

          <a
            href={communityData?.description || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="cm-link-card"
            style={{ textDecoration: "none" }}
          >
            <img src={grouplogo} alt="Group Logo" />

            <div className="cm-link-card-text">
              <div className="cm-link-card-label">
                COMMUNITY LINK
              </div>

              <div className="cm-link-card-handle">
                {communityData?.description}
              </div>
            </div>

            <img src={whitearrowicon} alt="Arrow" />
          </a>
        </div>

        {/* RIGHT SECTION */}
        <div className="cm-right">
          {communityData?.socialLinks?.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="cm-social-card"
              style={{ textDecoration: "none" }}
            >
              <img
                src={getSocialIcon(item.socialMediaName)}
                alt={item.socialMediaName}
              />

              <div className="cm-social-card-text">
                <div className="cm-social-card-platform">
                  {item.socialMediaName?.toUpperCase()}
                </div>

                <div className="cm-social-card-handle">
                  {item.username}
                </div>
              </div>

              <img src={whitearrowicon} alt="Arrow" />
            </a>
          ))}
        </div>
      </main>

      <span className="mt-4">
        <Footer />
      </span>
    </div>
  );
}